import { Component, OnInit } from '@angular/core';
import {SeoService} from '../../../services/seo/seo.service';

@Component({
  selector: 'app-internaltionl-stu',
  templateUrl: './internaltionl-stu.component.html',
  styleUrls: ['./internaltionl-stu.component.scss']
})
export class InternaltionlStuComponent implements OnInit {

  constructor(private seo: SeoService) { }

  ngOnInit(): void {
    this.seo.setMeta('International Students',
      'The faculty offers international students an intellectually challenging education through certificate, diploma, and undergraduate programmes that are international in scope and interactive in content and approach')
  }

}
